import * as React from 'react'
import { Image, ImageSourcePropType, StyleSheet, Text, TextStyle, TouchableOpacity, ViewStyle } from 'react-native'

import { fontFamily } from '../../theme'

interface CardButtonProps {
  name: string
  onPress: () => void
  btnStyle?: ViewStyle
  rightIcon?: ImageSourcePropType
  nameStyle?: TextStyle
}

/**
 *
 * This component is a HOC over the built-in React Native one.
 */
export function CardButton(props: CardButtonProps) {
  const { name, onPress, btnStyle, rightIcon, nameStyle } = props

  return (
    <TouchableOpacity
      style={[styles.button, { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }, { ...btnStyle }]}
      onPress={onPress}
    >
      <Text style={[styles.buttonText, nameStyle]}>{name}</Text>
      {rightIcon && <Image source={rightIcon} resizeMode="contain" style={{ width: 18, height: 18 }} />}
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  button: {
    paddingHorizontal: 30,
    paddingVertical: 10.5,
    backgroundColor: '#121212',
    borderRadius: 48
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: 18,
    fontFamily: fontFamily.GTAmericaStandardMedium
  }
})
